"use client";

import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import PageHero from "@/components/sections/PageHero";
import TestimonialCard from "@/components/shared/TestimonialCard";
import { getTestimonialsData } from "@/data/testimonials";
import { useLanguage } from "@/lib/i18n";
import { motion } from "framer-motion";

export default function TestimonialsClient() {
  const { language } = useLanguage();
  const testimonials = getTestimonialsData(language);

  const content = language === "id" ? {
    title: "Ulasan Tamu",
    subtitle: "Cerita dari mereka yang telah merasakan pengalaman KinKen Kost Elite",
  } : {
    title: "Guest Reviews",
    subtitle: "Stories from those who have experienced KinKen Kost Elite",
  };

  return (
    <main className="min-h-screen bg-white">
      <Navbar />
      <PageHero
        title={content.title}
        subtitle={content.subtitle}
        image="/images/hero/hero-main.webp" // Menggunakan hero utama sebagai fallback
      />

      <section className="py-20 md:py-32 bg-[#F9F9F9]">
        <div className="container mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((review, index) => (
              <motion.div
                key={review.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="h-full"
              >
                <TestimonialCard review={review} />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
